"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.anonymousUserIdPrefix = exports.cookieName = void 0;
exports.getAnonymousUserId = getAnonymousUserId;
exports.setAnonymousUserIdIfNotExists = setAnonymousUserIdIfNotExists;
const cookie_1 = require("cookie");
exports.cookieName = 'fuse_auid'; // auid here is short for "anonymous user id"
exports.anonymousUserIdPrefix = 'guest_';
const secondsInYear = 31536000;
function getAnonymousUserId() {
    if (typeof window === 'undefined') {
        return;
    }
    return (0, cookie_1.parse)(document.cookie)[exports.cookieName];
}
function setAnonymousUserIdIfNotExists() {
    if (typeof window === 'undefined') {
        return;
    }
    const userId = getAnonymousUserId();
    if (userId !== undefined) {
        return;
    }
    const randomUserId = `${exports.anonymousUserIdPrefix}${crypto.randomUUID()}`;
    document.cookie = `${exports.cookieName}=${randomUserId}; max-age=${secondsInYear}; SameSite=Lax`;
}
//# sourceMappingURL=anonymousUserTracker.js.map